import React from 'react';
import useSubscriptions from '@afosto/utils-react/subscription/useSubscriptions';
import Grid from '@material-ui/core/Grid';
import GeneralAppSettings from './GeneralAppSettings';
import ShipmentsSettings from './ShipmentsSettings';
import SpoolerSettings from './SpoolerSettings';
import LocationSettings from './LocationSettings';

const GeneralSettings = () => {
  const subscriptions = useSubscriptions();
  const hasSpoolerSubscription = subscriptions.some(subscription => subscription.code === 'spl');

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <LocationSettings />
      </Grid>
      <Grid item xs={12}>
        <GeneralAppSettings />
      </Grid>
      <Grid item xs={12}>
        <ShipmentsSettings />
      </Grid>
      {hasSpoolerSubscription && (
        <Grid item xs={12}>
          <SpoolerSettings />
        </Grid>
      )}
    </Grid>
  );
};

export default GeneralSettings;
